import { request } from './request'

export function queryOpenIdBySn(sn) {
  const url = process.env.NODE_ENV === 'production' ? '/api/blog/license/openid/' : '/blog/license/openid/';
  return request({
    url,
    method: 'post',
    timeout: 15000,
    data: { sn }
  })
}
